import * as React from 'react';
import { Link } from 'components/core';
export default ({ className }: { className?: string }) => (
  <Link external to="mailto:support@figure53.com" className={className}>
    support@figure53.com
  </Link>
);
